"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var match_1 = require("preact-router/match");
var header_scss_1 = __importDefault(require("./header.scss"));
var Header = function () { return (preact_1.h("header", { class: header_scss_1.default.header },
    preact_1.h("h1", null, "Preact App"),
    preact_1.h("nav", null,
        preact_1.h(match_1.Link, { activeClassName: header_scss_1.default.active, href: "/" }, "Home"),
        preact_1.h(match_1.Link, { activeClassName: header_scss_1.default.active, href: "/profile" }, "Me"),
        preact_1.h(match_1.Link, { activeClassName: header_scss_1.default.active, href: "/profile/john" }, "John")))); };
exports.default = Header;
//# sourceMappingURL=header.js.map


// WEBPACK FOOTER //
// ./components/header/header.js